import p1 from "@/assets/hello/p1.jpg";
import p3 from "@/assets/hello/p3.jpg";
import p5 from "@/assets/hello/p5.jpg";
import p2 from "@/assets/hello/p2.jpg";
import p4 from "@/assets/hello/p4.jpg";

const LernHooshVeidos = [
    { iframe: "https://www.aparat.com/video/video/embed/videohash/inohz34/vt/frame?titleShow=true", img: p1 },
    { iframe: "https://www.aparat.com/video/video/embed/videohash/zlvor9j/vt/frame?titleShow=true", img: p3 },
    { iframe: "https://www.aparat.com/video/video/embed/videohash/xzgq99r/vt/frame?titleShow=true", img: p5 },
    { iframe: "https://www.aparat.com/video/video/embed/videohash/xlv4o93/vt/frame?titleShow=true", img: p2 },
    { iframe: "https://www.aparat.com/video/video/embed/videohash/rbfeho7/vt/frame?titleShow=true", img: p4 },
];

export default LernHooshVeidos;
